exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://use.typekit.net/cyv5kyj.css);", ""]);
// Module
exports.push([module.id, "/* @import url('https://fonts.googleapis.com/css?family=Nunito+Sans&display=swap');\r\n */\r\n\r\nhtml, body {\r\n  font-family: aglet-sans, sans-serif;\r\n  overflow-x: hidden;\r\n}\r\nhtml * {\r\n  box-sizing: border-box;\r\n}\r\n", ""]);
